import { Alert, Switch } from "@xola/ui-kit";
import clsx from "clsx";
import React, { ReactNode } from "react";

interface OverrideAlertBoxProps {
    shouldOverride: boolean;
    switchText: string;
    children: ReactNode;
    onChange: (value: boolean) => void;
}

export const OverrideAlertBox = ({ shouldOverride, switchText, children, onChange }: OverrideAlertBoxProps) => {
    return (
        <Alert color="primary">
            <div className={clsx(!shouldOverride && "mb-5", "flex items-center space-x-2")}>
                <Switch size="medium" isChecked={shouldOverride} onChange={onChange} />
                <h5 className="font-bold">{switchText}</h5>
            </div>

            {!shouldOverride && <div>{children}</div>}
        </Alert>
    );
};
